import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header_wrapper" }
const _hoisted_3 = { class: "content_wrapper pa-2" }
const _hoisted_4 = { class: "text-body-1 text-blue-grey-darken-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_toolbar, {
        color: "primary",
        dark: "",
        class: "position-relative"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            icon: "",
            onClick: _ctx.routerBack,
            style: {"z-index":"2"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_toolbar_title, {
            class: "text-center position-absolute",
            style: {"left":"0","right":"0","pointer-events":"none","width":"100%","margin-left":"0"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('settingNotification.title')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            onClick: _ctx.putMe,
            loading: _ctx.btnLoading,
            text: "",
            class: "font-weight-bold",
            style: {"z-index":"2"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('settingNotification.save')), 1)
            ]),
            _: 1
          }, 8, ["onClick", "loading"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (n) => {
        return (_openBlock(), _createElementBlock("div", {
          key: n.key
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(n.label), 1),
          _createVNode(_component_v_select, {
            color: "primary",
            "base-color": "primary",
            modelValue: n.value,
            "onUpdate:modelValue": ($event: any) => ((n.value) = $event),
            items: _ctx.options,
            "item-title": "text",
            "item-value": "value",
            variant: "outlined",
            density: "compact"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
        ]))
      }), 128))
    ])
  ]))
}